import React from 'react'
import DataTable from "react-data-table-component";


export default function DataTableComponent(props) {

  return (
    <>
      <DataTable
        columns={props.columns}
        data={props.data}
        defaultSortFieldId={1}
        title={props.title}
      />

    </>
  )
}
